import React from 'react';

const Page404 = () => {
  return (
    <article className='error-container'>
      <h3 className='error-message'>Error 404</h3>
      <h3 className='error-message'>
        Lo sentimos la pàgina que busca no se encuentra disponible
      </h3>
    </article>
  );
};

export default Page404;
